module.exports = __webpack_public_path__ + "img/integrations-bg.9b1026f5.png";